import React from "react"
import SEO from "src/components/SEO"
import { OffersSlider } from "src/components/OffersSlider"
import InViewMonitor from "react-inview-monitor"
import CookiePolicyScript from "src/components/CookiePolicyScript"

const CookiePolicy: React.FC = () => {
  return (
    <>
      <SEO title="Cookie Policy" />

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 mt-xl">
            <h1>Cookie Policy</h1>
            <CookiePolicyScript />
          </div>
        </div>
      </div>

      <InViewMonitor classNameNotInView="animate-box" classNameInView="animated fadeInUp">
        <OffersSlider />
      </InViewMonitor>
    </>
  )
}

export default CookiePolicy
